import Grid from "@mui/material/Grid";
import {RhfTextField} from "mui-rhf-integration";
import type {ReactNode} from "react";
import {useFormContext} from "react-hook-form";
import type {PaymentFormSchemaType} from "@/components/Forms/PaymentForm.tsx";

const InPersonCheck = (): ReactNode => {
    const {control} = useFormContext<PaymentFormSchemaType>();
    return (
        <Grid container spacing={1} sx={{width: "100%"}}>
            <Grid size={8}>
                <RhfTextField
                    control={control}
                    name={"checkNumber"}
                    label={"Check Number"}
                    fullWidth
                />
            </Grid>
        </Grid>
    );
};

export default InPersonCheck;
